import { LayoutDashboard, PlusCircle, ListChecks, Receipt, MapPin, Settings } from "lucide-react";
import DashboardShell from "@/components/DashboardShell";

const NAV = [
  { label: "Overview", to: "/merchant", icon: LayoutDashboard, end: true },
  { label: "New delivery", to: "/merchant/create", icon: PlusCircle },
  { label: "Orders", to: "/merchant/orders", icon: ListChecks },
  { label: "Billing", to: "/merchant/billing", icon: Receipt },
  { label: "Locations", to: "/merchant/locations", icon: MapPin },
  { label: "Profile", to: "/merchant/profile", icon: Settings },
];

export default function MerchantLayout() {
  return <DashboardShell roleTag="Merchant Console" navItems={NAV} />;
}
